import React from "react";

const asArray = (value) => Array.isArray(value) ? value : [];

export const allowsMinutesUi = (sport) => !["NFL", "CFB"].includes(String(sport || "").toUpperCase());

export const observedNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export function cfbEligibilityReasons(value) {
  return String(value || "").split(";").map((reason) => reason.trim()).filter(Boolean);
}

export function cfbEligibilityLabel(row) {
  return row?.["Guru Pick Eligible"] === true ? "Guru Eligible" : "Not Guru Eligible";
}

export function cfbOpportunitySignal(row) {
  const prop = String(row?.["Prop Type"] || "");
  const games = asArray(row?.Last10);
  const latest = games.find((game) => game && typeof game === "object") || {};
  const candidates = /pass yards|pass tds|\bint\b/i.test(prop)
    ? ["Pass Attempts", latest.pass_attempts]
    : /rush yards|rush tds/i.test(prop)
      ? ["Carries", latest.carries ?? latest.rush_attempts]
      : /fg made/i.test(prop)
        ? ["FG Attempts", latest.fg_attempts]
        : null;
  if (!candidates || candidates[1] === null || candidates[1] === undefined || candidates[1] === "" || !Number.isFinite(Number(candidates[1]))) return null;
  return `${candidates[0]}: ${Number(candidates[1])}`;
}

export const footballOpportunitySignal = cfbOpportunitySignal;

export function CFBEligibilityDisplay({ row, admin = false }) {
  const eligible = row?.["Guru Pick Eligible"] === true;
  const reasons = cfbEligibilityReasons(row?.["Guru Pick Exclusion Reason"]);
  if (!admin) {
    return <span data-testid="cfb-eligibility-public">{cfbEligibilityLabel(row)}</span>;
  }
  return (
    <div data-testid="cfb-eligibility-admin" style={{ minWidth: 0, maxWidth: "100%" }}>
      <div>{eligible ? "ELIGIBLE" : "NOT ELIGIBLE"}</div>
      {!eligible && reasons.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 6, maxWidth: "100%" }}>
          {reasons.map((reason) => (
            <span key={reason} style={{ maxWidth: "100%", overflowWrap: "anywhere", wordBreak: "break-word", whiteSpace: "normal", borderRadius: 999, padding: "3px 8px", background: "#FEF3C7", color: "#92400E" }}>
              {reason.replaceAll("_", " ")}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
